import { InjectionToken } from '@angular/core';

import { SignagePushClient } from 'app/shared/models';

export const SIGNAGE_PUSH_CLIENT = new InjectionToken<(ownerUuid: string) => SignagePushClient>('SignagePushClient');
